import React from 'react'
import styled from 'styled-components'

// Styled components for better maintainability
const Container = styled.div`
  background: #1b1c21;
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 481px;
  padding: 32px;
  border-radius: 16px;
  box-sizing: border-box;
`

const StatRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`

const StatLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

const StatLabel = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.4;
  margin: 0;
`

const StatValue = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: white;
  line-height: 1.2;
  margin: 0;
  word-break: break-word;
`

const StatChange = styled.div`
  white-space: nowrap;
  line-height: 1.2;
  align-self: flex-start;
  margin-top: 20px;
  color: #fff;
`

const Divider = styled.div`
  background: #222328;
  height: 1px;
  width: 100%;
`

const StatsSection = ({
  liquidity,
  liquidityChange,
  liquidityChangeUSD,
  volume,
  volumeChange,
  volumeChangeUSD,
  oneDayTxns,
  txnChange,
  txnChangeRaw,
}) => {
  return (
    <Container>
      {/* Total Liquidity */}
      <StatRow>
        <StatLeft>
          <StatLabel>Total Liquidity</StatLabel>
          <StatValue>{liquidity}</StatValue>
        </StatLeft>
        <StatChange>{liquidityChange}</StatChange>
      </StatRow>

      <Divider />

      {/* 24h Volume */}
      <StatRow>
        <StatLeft>
          <StatLabel>Volume (24hrs)</StatLabel>
          <StatValue>{volume}</StatValue>
        </StatLeft>
        <StatChange>{volumeChange}</StatChange>
      </StatRow>

      <Divider />

      {/* 24h Transactions */}
      <StatRow>
        <StatLeft>
          <StatLabel>24h Transactions</StatLabel>
          <StatValue>{oneDayTxns ? oneDayTxns.toLocaleString() : 0}</StatValue>
        </StatLeft>
        <StatChange>{txnChange}</StatChange>
      </StatRow>
    </Container>
  )
}

export default StatsSection
